import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({ 
    spinner: {
        marginTop: '20vh',
        color: '#122230',
    },
}))

export default useStyles
